import SmartLink from '../../lib/includes/components/component.smartlink';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import React from "react";

import LogoUrl from './../../assets/img/logo.svg';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars, faXmark} from "@fortawesome/pro-light-svg-icons";

const Header = (props) => {
	if (!props.general) {
		return null;
	}

	return <header className="site-header">
		<div className="container container-max">
			<div className="row align-items-center">
				<div className="col">
					<Link to="/" className="logo">
						<img src={LogoUrl} alt={props.general.title} />
					</Link>
				</div>
				<div className="col text-end">
					<button onClick={props.toggleMenu} className={"menu-burger " + (props.menu.menu_toggled ? " toggled" : "")}>
						<FontAwesomeIcon className={"icon"} icon={props.menu.menu_toggled ? faXmark : faBars} />
					</button>
				</div>
			</div>
		</div>

		<div className={"site-navigation" + (props.menu.menu_toggled ? " open" : "")}>
			{props.menu.menus.main_menu &&
				<ul>
					{props.menu.menus.main_menu.items.filter(item => item.parent == 0).map((item, i) => {
						return <li key={item.id}>
							<SmartLink activeClassName="current" url={item.url} target={item.target}>{item.title}</SmartLink>
						</li>
					})}
				</ul>
			}
		</div>

	</header>
};
export default connect(
	state => {
		return {
			menu: state.menuState,
			general: state.generalState.general,
			headerStyle: state.pageState.page?.headerStyle,
			custom: state.customState
		}
	},
	(dispatch) => {
		return {
			toggleMenu: () => {
				dispatch({
					type: 'MENU_TOGGLED'
				})
			},
			toggleSubMenu: (id, e) => {

				e.preventDefault();
				dispatch({
					type: 'SUBMENU_TOGGLED',
					id: id
				})
			},
		}
	}
)(Header);
